var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.693359,
    y: 0.03125,
    width: 30.8365,
    height: 30.8365,
    rx: 15.4182,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5998 21.5027C10.4746 21.3832 10.3922 21.241 10.3524 21.076C10.3125 20.9054 10.3125 20.7376 10.3524 20.5726C10.3979 20.4077 10.4803 20.2683 10.5998 20.1546L14.755 15.9908L10.5998 11.8356C10.4803 11.7219 10.3979 11.5825 10.3524 11.4176C10.3125 11.2526 10.3125 11.0876 10.3524 10.9227C10.3922 10.752 10.4746 10.607 10.5998 10.4875C10.7249 10.3624 10.87 10.2799 11.0349 10.2401C11.1999 10.2003 11.3648 10.2031 11.5298 10.2486C11.6948 10.2885 11.837 10.3653 11.9564 10.479L16.1116 14.6427L20.2668 10.479C20.3863 10.3596 20.5285 10.2799 20.6934 10.2401C20.8584 10.2003 21.0205 10.2031 21.1798 10.2486C21.3447 10.2885 21.4898 10.3681 21.6149 10.4875C21.74 10.607 21.8225 10.752 21.8623 10.9227C21.9022 11.0876 21.9022 11.2526 21.8623 11.4176C21.8225 11.5768 21.74 11.719 21.6149 11.8442L17.4682 15.9908L21.6149 20.1546C21.74 20.274 21.8225 20.4162 21.8623 20.5812C21.9022 20.7404 21.9022 20.9054 21.8623 21.076C21.8225 21.241 21.74 21.3832 21.6149 21.5027C21.4898 21.6221 21.3447 21.7046 21.1798 21.7501C21.0205 21.7899 20.8584 21.7899 20.6934 21.7501C20.5285 21.7103 20.3863 21.6306 20.2668 21.5112L16.1116 17.3475L11.9564 21.5112C11.837 21.6306 11.6948 21.7103 11.5298 21.7501C11.3648 21.7899 11.1999 21.7899 11.0349 21.7501C10.87 21.7103 10.7249 21.6278 10.5998 21.5027Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseDrawer);
export default __webpack_public_path__ + "static/media/icon-close-drawer.d3964bd35be1c2c559a7764c94a3a0f3.svg";
export { ForwardRef as ReactComponent };